import { render, staticRenderFns } from "./create-citation-for-all-papers.html?vue&type=template&id=320ca35c&scoped=true&external"
import script from "./create-citation-for-all-papers.js?vue&type=script&lang=js&external"
export * from "./create-citation-for-all-papers.js?vue&type=script&lang=js&external"
import style0 from "./create-citation-for-all-papers.scss?vue&type=style&index=0&id=320ca35c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320ca35c",
  null
  
)

export default component.exports